import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getContactBillingInfosByID = (ID) => Axios.get(`/contacts/billinginfos/${ID}`);

const useContactBillingInfos = (ID) => {
    const disableQuery = !ID || isNaN(parseInt(ID));
    const intID = !disableQuery ? parseInt(ID) : null;
    return useQuery({
        queryKey: ['contactbillinginfos', intID],
        queryFn: () => getContactBillingInfosByID(intID),
        staleTime: 30000,
        cacheTime: 30000,
        enabled: !disableQuery,
    });
};

const forceReloadContactBillingInfos = (ID) => {
    const intID = Number(ID);
    queryClient.invalidateQueries({ queryKey: ['contactbillinginfos', intID] });
};

// Liste complete delle billing infos: ogni voce porta i ContactIDs a cui e' associata.
const getAllBillingInfosForCustomers = () => Axios.get('/BillingInfos/GetAllForCustomers');
const getAllBillingInfosForModels = () => Axios.get('/BillingInfos/GetAllForModels');

const useAllBillingInfosForCustomers = (enabled) => {
    return useQuery({
        queryKey: ['billinginfos-customers'],
        queryFn: getAllBillingInfosForCustomers,
        staleTime: 300000,
        cacheTime: Infinity,
        retry: false,
        enabled: enabled,
    });
};

const useAllBillingInfosForModels = (enabled) => {
    return useQuery({
        queryKey: ['billinginfos-models'],
        queryFn: getAllBillingInfosForModels,
        staleTime: 300000,
        cacheTime: Infinity,
        retry: false,
        enabled: enabled,
    });
};

export {
    useContactBillingInfos,
    forceReloadContactBillingInfos,
    useAllBillingInfosForCustomers,
    useAllBillingInfosForModels,
};
